import { render, staticRenderFns } from "./Prop65Warning.vue?vue&type=template&id=1016ed6d&scoped=true"
import script from "./Prop65Warning.vue?vue&type=script&setup=true&lang=ts"
export * from "./Prop65Warning.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Prop65Warning.vue?vue&type=style&index=0&id=1016ed6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1016ed6d",
  null
  
)

export default component.exports